import type { HttpCartDto } from '@/modules/cart/infrastructure/dto/HttpCartRepositoryDto';
import httpClient from '@/modules/cart/services/api/client';
import environment from '@/modules/perseo-billing/environments/environment';

const { CLUB_PARIS_URL } = environment;

export async function deleteClubParis(): Promise<{ data: HttpCartDto }> {
  const response = await httpClient.delete(CLUB_PARIS_URL, {
    timeout: 15000
  });
  return Promise.resolve(response);
}
